import { useState } from 'react'
import { getFromLocalStorage, updatePersistentConfigs } from './workspaceUtils'

export interface LocalStorageInput {
    key: string
    value?: any
}
export interface AELocalStorageInput {
    key: string
    value?: any
    userId: string
    projectId: string
}

export const useLocalStorage = (input: LocalStorageInput) => {
    const { key, value } = input
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const saved = localStorage.getItem(key)
            if (!!saved) {
                if (saved === 'true' || saved === 'false') {
                    return saved === 'true'
                } else {
                    return saved
                }
            } else if (!!value) {
                localStorage.setItem(key, value)
            }

            return value
        } catch {
            return value
        }
    })

    const handleStoredValueUpdate = (newValue: any) => {
        if (newValue !== undefined) {
            localStorage.setItem(key, newValue)
        } else if (newValue === undefined) {
            localStorage.removeItem(key)
        }
        setStoredValue(newValue)
    }
    return [storedValue, handleStoredValueUpdate]
}

export const useAELocalStorage = (input: AELocalStorageInput) => {
    const { key, value, userId, projectId } = input
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const saved = getFromLocalStorage(userId, projectId, key)
            if (!!saved) {
                return saved
            } else if (!!value) {
                updatePersistentConfigs(userId, projectId, key, value)
            }

            return value
        } catch {
            return value
        }
    })

    const handleStoredValueUpdate = (newValue: any) => {
        updatePersistentConfigs(userId, projectId, key, newValue)
        setStoredValue(newValue)
    }
    return [storedValue, handleStoredValueUpdate]
}

export const useAELocalStorageWriteOnly = (input: AELocalStorageInput) => {
    const { key, userId, projectId } = input
    const handleStoredValueUpdate = (newValue: any) => {
        updatePersistentConfigs(userId, projectId, key, newValue)
    }
    return [handleStoredValueUpdate]
}

export const getStoredValue = (key: string) => {
    const savedValue = localStorage.getItem(key)
    if (savedValue === 'true' || savedValue === 'false') {
        return savedValue === 'true'
    } else {
        return savedValue
    }
}

export const storeValue = (key: string, value: any) => {
    localStorage.setItem(key, value)
}

type Nullable<T> = T | null | undefined
/**
 * Checks if two strings are equal (case-insensitive).
 *
 * @param {Nullable<string>} str1 - The first string to compare.
 * @param {Nullable<string>} str2 - The second string to compare.
 * @returns {boolean} - Returns true if the strings are equal (case-insensitive), false otherwise.
 */
export const areEq = (
    str1: Nullable<string>,
    str2: Nullable<string>
): boolean => {
    if (str1 != null && str2 != null) {
        return (
            str1.localeCompare(str2, undefined, { sensitivity: 'base' }) === 0
        )
    }

    return false
}